import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { NAVY, TEAL, SLATE, rs, loadImage, drawHeader, drawFooter } from "@/lib/pdfBrand";

// Admin analytics/report export — aggregate business report, human-readable identifiers only.
// Does NOT touch the customer Statement/Receipt PDFs.
export async function generateReportPdf(d, meta = {}) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const mascot = await loadImage("/brand/zrope-icon.png");
  drawHeader(doc, { rightTitle: (meta.title || "ANALYTICS REPORT").toUpperCase(), rightSub: `Generated: ${new Date().toLocaleString("en-IN")}`, mascot });

  const o = d.overview;
  let y = 122;
  doc.setTextColor(...NAVY); doc.setFont("helvetica", "bold"); doc.setFontSize(14);
  doc.text(meta.title || "Analytics Report", 40, y);
  doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor(...SLATE);
  doc.text(`Period: ${d.range.from} to ${d.range.to} (${d.range.days} days)   •   Data scope: ${d.include_demo ? "Includes TEST data" : "Live data only"}`, 40, y + 16);

  autoTable(doc, {
    startY: y + 28,
    head: [["Executive KPI", "Value"]],
    body: [
      ["Total Customers", String(o.total_customers)],
      ["Active Customers", String(o.active_customers)],
      ["Total Loans", `${o.total_loans} (${o.active_loans} active / ${o.closed_loans} closed)`],
      ["Total Disbursed", rs(o.total_disbursed)],
      ["Total Collected", rs(o.total_collected)],
      ["Outstanding", rs(o.outstanding)],
      ["Collection Rate", `${o.collection_rate}%`],
      ["Payment Success Rate", `${o.success_rate}%  (${o.payment_success} paid)`],
      ["Payment Failure Rate", `${o.failure_rate}%  (${o.payment_failed} failed)`],
    ],
    theme: "grid", headStyles: { fillColor: NAVY, textColor: 255, fontSize: 9, fontStyle: "bold" },
    styles: { fontSize: 9, cellPadding: 5 }, columnStyles: { 1: { fontStyle: "bold", halign: "right" } },
    margin: { left: 40, right: 40 },
  });

  const section = (title) => {
    doc.setFont("helvetica", "bold"); doc.setFontSize(10); doc.setTextColor(...TEAL);
    doc.text(title, 40, doc.lastAutoTable.finalY + 20);
  };

  section("LENDER PERFORMANCE");
  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 26,
    head: [["Lender", "Loans", "Active", "Disbursed", "Collected", "Outstanding", "Success%"]],
    body: d.lenders.map((l) => [l.lender, String(l.loans), String(l.active), rs(l.disbursed), rs(l.collected), rs(l.outstanding), `${l.success_rate}%`]),
    theme: "striped", headStyles: { fillColor: NAVY, textColor: 255, fontSize: 8 }, styles: { fontSize: 8, cellPadding: 4 },
    margin: { left: 40, right: 40 },
  });

  const totalAg = d.aging.reduce((s, x) => s + x.amount, 0) || 1;
  section("OUTSTANDING AGING");
  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 26,
    head: [["Bucket", "Outstanding", "Loans", "% Portfolio"]],
    body: d.aging.map((b) => [b.bucket, rs(b.amount), String(b.loans), `${Math.round(100 * b.amount / totalAg)}%`]),
    theme: "grid", headStyles: { fillColor: NAVY, textColor: 255, fontSize: 8 }, styles: { fontSize: 8, cellPadding: 4 },
    margin: { left: 40, right: 40 },
  });

  const drows = (arr) => arr.map((x) => [x.name, String(x.value)]);
  section("DISTRIBUTIONS");
  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 26,
    head: [["Loan Status", "Count"]], body: drows(d.loans.status_dist),
    theme: "plain", headStyles: { fillColor: TEAL, textColor: 255, fontSize: 8 }, styles: { fontSize: 8, cellPadding: 3 },
    tableWidth: 230, margin: { left: 40 },
  });
  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 12,
    head: [["Payment Method", "Count"]], body: drows(d.payments.method_dist),
    theme: "plain", headStyles: { fillColor: TEAL, textColor: 255, fontSize: 8 }, styles: { fontSize: 8, cellPadding: 3 },
    tableWidth: 230, margin: { left: 40 },
  });

  const pages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pages; i++) {
    doc.setPage(i);
    drawFooter(doc, { line1: "ZRO PE FINTECH PRIVATE LIMITED", line2: "Support: support@zrope.in   |   www.zrope.in", page: i, pages });
  }
  doc.save(`ZRoPe-Report-${(meta.slug || "analytics")}-${d.range.from}.pdf`);
}
